// src/services/ProfileManagementAPI.js
import axios from 'axios';
import UserProfile from "components/UserProfile/UserProfile";
import { apiUrl as API_BASE_URL } from 'config';

// Create axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${UserProfile.getToken()}` // initial token
    }
});

// Request interceptor to update token dynamically
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken(); // assuming async
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

const viewUrlPath = 'user-management/';
const groupsViewUrlPath = 'groups/';

export const ProfileManagementAPI = {
    // Paginated fetch with optional search and page size
    getAll: (page, pageSize, search) => {
        const params = {
            page,
            page_size: pageSize,
        };
        if (search) params.search = search;
        return api.get(viewUrlPath, { params });
    },

    getById: (id) => api.get(`${viewUrlPath}${id}/`),
    getOperatingUser: () => api.get(`${viewUrlPath}me/`),

    update: (id, data) => api.put(`${viewUrlPath}${id}/`, data),
    updateUser: (id, data) => api.patch(`${viewUrlPath}${id}/user/`, data),
    updatePermissions: (id, data) => api.patch(`${viewUrlPath}${id}/permissions/`, data),
    updateGroups: (id, data) => api.patch(`${viewUrlPath}${id}/groups/`, data),
    getGroups: (page, pageSize, search) => {
        const params = {};
        if (page) params.page = page;
        if (pageSize) params.page_size = pageSize;
        if (search) params.search = search;
        return api.get(groupsViewUrlPath, { params });
    },
    deactivateUser: (id) => api.patch(`${viewUrlPath}${id}/deactivate/`),
    patch: (id, data) => api.patch(`${viewUrlPath}${id}/`, data),
};
